function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" viewBox="0 0 13 16" {...props}><path d="M12.5 0a.5.5 0 0 1 .5.5V15a.5.5 0 0 1-.854.354L10.5 13.707l-1.649 1.647a.5.5 0 0 1-.637.057l-.07-.057-1.646-1.647-1.646 1.647a.5.5 0 0 1-.638.057l-.07-.057L2.5 13.707.854 15.353A.5.5 0 0 1 0 15V.5A.5.5 0 0 1 .5 0zM12 1.001H1v12.792l1.144-1.146a.5.5 0 0 1 .638-.058l.07.057 1.646 1.647 1.646-1.647a.5.5 0 0 1 .638-.057l.07.057 1.647 1.648 1.648-1.648a.5.5 0 0 1 .707 0L12 13.794V1.001zm-4 5.5v1H3v-1h5zm2-3v1H3v-1h7z" fillRule="nonzero" /></svg>;
});